var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 700 700",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#929993",
    strokeMiterlimit: 10,
    strokeWidth: 56.6929
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.4 276.9c0 67.5-27.4 128.6-71.6 172.8s-105.3 71.7-172.8 71.7c-135 0-244.4-109.4-244.4-244.4s109.4-244.5 244.4-244.5 244.4 109.4 244.4 244.4z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m666.2 665.6-210.6-210.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.6 126s-156 73.5-93.4 242.7"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "search-icon.aa7a7f6fcf3f8e341d8d2e5052095840.svg";